<section id="footer">
  <div class="container pt-5">
    <div class="row">
      <div class="col-sm-6 col-xl-4">
        <div class="footer-column">
          <img src="assets/images/footer/gift-image.png" alt="gift image">
          <p>{{"FOOTER.FOOTER_PARAGRAPH" | translate}}</p>
          <h4>{{"FOOTER.CONTACT_WITH_US" | translate}}</h4>
          <div class="contact-icons">
            <div class="icon" *ngFor="let item of socialMediaData">
              <a [href]="item.url" target="_blank">
                <img [src]="item.icon" [alt]="item.name + ' icon'">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4">
        <div class="footer-column">
          <div class="column-title">
            <h3>{{"FOOTER.LINKS" | translate}} <span></span></h3>
            <div class="line"></div>
          </div>
          <ul>
            <li routerLink="/home">
              <a>{{ "FOOTER.HOME" | translate}}</a>
            </li>
            <li routerLink="/rooms">
              <a>{{ "FOOTER.ROOMS" | translate}}</a>
            </li>
            <li  routerLink="/special-gifts">
              <a>{{ "FOOTER.SPECIAL_GIFTS" | translate}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4">
        <div class="footer-column">
          <div class="column-title">
            <h3>{{"FOOTER.CONTACT_INFO" | translate}} <span></span></h3>
            <div class="line"></div>
          </div>
          <ul>
            <li>
              <div class="label">
                <strong>
                  {{"FOOTER.ADDRESS" | translate}}
                </strong>
              </div>
              <div class="text">
                <span *ngIf=" TranslateService.currentLang === 'ar-SA'" >
                  {{ settingsData['address_ar'] }}
                </span>
                <span *ngIf=" TranslateService.currentLang === 'en-US'">
                  {{ settingsData['address_en'] }}
                </span>
              </div>
            </li>
            <li>
              <div class="label">
                <strong>
                  {{"FOOTER.EMAIL" | translate}}
                </strong>
              </div>
              <div class="text">
                <span>
                  {{ settingsData['email'] }} 
                
                </span>
              </div>
            </li>
            <li>
              <div class="label">
                <strong>
                  {{"FOOTER.PHONE_NUMBER" | translate}}
                </strong>
              </div>
              <div class="text">
                <span>
                  {{ settingsData['phone'] }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
